/* eslint-disable */

import React, { useState, useCallback, useEffect } from "react";
import PARSE from "html-react-parser";
import { useSelector } from "react-redux";
import { Fade, Reveal, Zoom } from "react-reveal";
import Api from "./Api";
import HandleWatchingState from "../../context/HandleWatchingState";
import clsxm from "../../context/clsxm";

export default function SSoft_Solution_Key_Features() {
  const activeLang = useSelector((state) => state.content.activeLanguage);

  const [sections, setSections] = useState([]);
  console.log(
    "🚀 ~ file: SSoft_Solution_Key_Features.jsx:14 ~ SSoft_Solution_Key_Features ~ sections:",
    sections
  );

  const getSectionDetail = useCallback(() => {
    const api = new Api();
    api
      .getSectionDetail({ language: activeLang })
      .then((res) => {
        setSections(res.data.results);
      })
      .catch((err) => {
        console.log("err", err);
      });
    // console.log(response);
  }, [activeLang]);

  useEffect(() => {
    getSectionDetail();
  }, [getSectionDetail]);

  let title;
  let cardFeature;
  let background;
  if (sections) {
    const sec = sections[0]?.widgets;
    if (sec && sec.length !== 0) {
      sec.forEach((section, i) => {
        switch (i) {
          case 0: {
            const titleContent =
              section?.widget_contents ?? section.widget_contents[0];
            if (titleContent && titleContent.length !== 0) {
              title = titleContent[0];
            }
            break;
          }
          case 1: {
            const feature =
              section?.widget_contents ?? section.widget_contents[0];
            if (feature && feature.length !== 0) {
              cardFeature = feature;
            }
            break;
          }
          case 2: {
            const image =
              section?.widget_contents ?? section.widget_contents[0];
            if (image && image.length !== 0) {
              background = image;
              console.log(
                "🚀 ~ file: SSoft_Solution_Key_Features.jsx:66 ~ sec.forEach ~ background:",
                background
              );
            }
            break;
          }
          default:
            break;
        }
      });
    }
  }
  // const getColorFromSectionId = [
  //   { 928: "force-black" },
  //   { 944: "force-white" },
  //   { 947: "force-white" },
  //   { 951: "force-black" },
  // ];

  const getColorFromSectionId = (id) => {
    const colorMapping = [
      { 928: "force-black" },
      { 944: "force-white" },
      { 947: "force-white" },
      { 951: "force-black" },
    ];

    // Find the entry in the array with the matching id
    const entry = colorMapping.find((item) => item.hasOwnProperty(id));

    // Return the corresponding value if found, otherwise return null or a default value
    return entry ? entry[id] : null; // You can set a default value, like "default-color" if desired.
  };

  return (
    sections &&
    sections.length > 0 && (
      <div className="  relative">
        <div className="section-container section-margin-x ">
          <div className="absolute -z-[0] left-0 w-full !max-h-[182px]">
            {background && background.length > 0 && (
              <img
                height="auto"
                width="auto"
                src={background[0]?.file}
                alt={background[0]?.description}
                className="w-full !max-h-[182px]"
              />
            )}
          </div>
          <div
            className={clsxm(
              "flex md:flex-row flex-col  mx-auto w-full items-center py-[75px] z-10 ",
              "force-white"
              // getColorFromSectionId(sections[0].id)
            )}
          >
            <div className="w-full flex flex-col z-10 md:pt-0 pt-[45px] ">
              <div className=" ">
                {title?.article_language?.title && (
                  <div className="hdxl:text-[16px] text-[14px] font-[500] leading-[120%]  pb-[15px] tracking-[0.42px]">
                    {title?.article_language?.title}
                  </div>
                )}
                <div className="hdxl:max-w-[630px] max-w-[557px]">
                  {title?.article_language?.content && (
                    <div className="prose hdxl:prose-p:text-[32px] xl:prose-p:text-[29px] prose-p:text-[27px]  prose-p:leading-[150%]  font-inter-bold ">
                      {PARSE(title?.article_language?.content)}
                    </div>
                  )}
                </div>
                <div className="grid sm:grid-cols-2 grid-cols-1 mdl:mt-[80px] mt-[40px] gap-x-[80px] ">
                  {cardFeature?.map((feat, i) => (
                    <div
                      className={clsxm(
                        "flex flex-col  pb-[30px] ",
                        i % 2 !== 0 ? "ml-auto" : ""
                      )}
                    >
                      <div className="">
                        <img
                          src={feat?.assets[0]?.asset_file}
                          alt=""
                          className="w-[30px] h-[30px] hdxl:w-[34px] hdxl:h-[34px] mb-[25px] fill-white"
                        />

                        <div className="content-header-style-non-hero !text-white pb-[10px]">
                          {feat?.article_language?.title}
                        </div>
                        <div className="content-subheader-style-non-hero">
                          {PARSE(feat?.article_language?.content)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute -z-[0] left-0 bottom-0 !max-h-[393px] w-full">
          {background && background.length > 0 && (
            <img
              height="auto"
              width="auto"
              src={background[1]?.file}
              alt={background[1]?.description}
              className="w-full h-full !max-h-[393px] "
            />
          )}
        </div>

        <div className="absolute -z-[1] left-0 top-0  w-full h-full ">
          {background && background.length > 2 && (
            <picture className="h-full w-full">
              <source
                media="(max-width: 576px)"
                srcSet={background[2]?.asset_mobile}
                sizes="576px"
              />
              <source srcSet={background[2]?.file} sizes="100vw" />
              <img
                src={background[2]?.file}
                className="w-full h-full object-cover"
                alt={background[2]?.description}
              />
            </picture>
          )}
        </div>
      </div>
    )
  );
}
